import { createContext, useContext, useState, useEffect } from 'react';

const SettingsContext = createContext();

export const useSettings = () => {
  const context = useContext(SettingsContext);
  if (!context) {
    throw new Error('useSettings must be used within SettingsProvider');
  }
  return context;
};

export const SettingsProvider = ({ children }) => {
  const [dateFormat, setDateFormat] = useState('MM/DD/YYYY'); // 'MM/DD/YYYY', 'DD/MM/YYYY', or 'YYYY-MM-DD'
  const [timeFormat, setTimeFormat] = useState('12h'); // '12h' or '24h'

  // Load settings from localStorage on mount
  useEffect(() => {
    const savedDateFormat = localStorage.getItem('dateFormat') || 'MM/DD/YYYY';
    const savedTimeFormat = localStorage.getItem('timeFormat') || '12h';
    
    setDateFormat(savedDateFormat);
    setTimeFormat(savedTimeFormat);
  }, []);

  const updateDateFormat = (format) => {
    setDateFormat(format);
    localStorage.setItem('dateFormat', format);
  };

  const updateTimeFormat = (format) => {
    setTimeFormat(format);
    localStorage.setItem('timeFormat', format);
  };

  return (
    <SettingsContext.Provider
      value={{
        dateFormat,
        timeFormat,
        updateDateFormat,
        updateTimeFormat
      }}
    >
      {children}
    </SettingsContext.Provider>
  );
};